import { motion } from "framer-motion";

const items = [
    {
        title: "稳定可靠",
        desc: "自研权威 DNS 解析系统，极高可用性保障，确保网站长期稳定运行，为业务提供持久可靠的基础",
        img: "/icons/stable.png",
    },
    {
        title: "安全防御",
        desc: "内置多层防护机制，每秒承载亿次查询，抵御各种 DNS 攻击威胁，保护业务核心数据安全",
        img: "/icons/security.png",
    },
    {
        title: "全链路 DNS",
        desc: "提供从权威到递归节点的全链路 DNS 服务，满足企业多样化解析需求，实现解析全流程可控",
        img: "/icons/fullchain.png",
    },
    {
        title: "全球节点",
        desc: "全球 30+ 节点智能调度，为用户提供快速访问与最低延迟体验，保障跨地域业务访问质量",
        img: "/icons/global.png",
    },
];

const WhyChooseUs = () => {
    return (
        <section className="py-24 px-6 bg-gradient-to-b from-white to-slate-50">
            <h2 className="text-4xl font-bold text-center text-gray-800 mb-20">产品优势</h2>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-8 max-w-7xl mx-auto">
                {items.map((item, idx) => (
                    <motion.div
                        key={idx}
                        className="bg-white shadow rounded-2xl p-6 text-center hover:shadow-lg transition border border-gray-100"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: idx * 0.1 }}
                        viewport={{ once: true, amount: 0.3 }}
                    >
                        <div className="flex justify-center mb-4">
                            <img src={item.img} alt={item.title} className="w-14 h-14 object-contain" />
                        </div>
                        <h3 className="text-lg font-semibold text-gray-800 mb-2 leading-tight">{item.title}</h3>
                        <p className="text-sm text-gray-600 leading-relaxed min-h-[4.5rem] flex items-center justify-center">
                            {item.desc}
                        </p>
                    </motion.div>
                ))}
            </div>
        </section>
    );
};

export default WhyChooseUs;